"use client";

import { forwardRef, useState } from "react";

import { VisibilityIcon, VisibilityOffIcon } from "@saas/shared/icon";

import { BaseInput, BaseInputProps } from "../../base-input/base-input";

export interface IPasswordInputProps
  extends Omit<BaseInputProps, "type" | "action"> {
  testid?: string;
}

export const PasswordInput = forwardRef<HTMLInputElement, IPasswordInputProps>(
  ({ testid = "", ...props }, ref) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
      <BaseInput
        ref={ref}
        type={showPassword ? "text" : "password"}
        action={{
          icon: showPassword ? VisibilityIcon : VisibilityOffIcon,
          onClick: () => setShowPassword((prevState) => !prevState),
          testid: testid + "__icon__eye",
        }}
        testid={testid}
        {...props}
      />
    );
  }
);

PasswordInput.displayName = "PasswordInput";
